import { createComment, deleteComment, listComments, updateComment } from "../../api/comment";

const comments = {
    namespaced: true,
    state: {
        comments: [],
    },
    getters: {
        allComments(state) {
            return state.comments;
        },
    },
    mutations: {
        ADD_COMMENT(state, comment) {
            state.comments.unshift(comment);
        },
        SET_COMMENTS(state, comments) {
            state.comments = comments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        },
        REMOVE_COMMENT(state, commentId) {
            state.comments = state.comments.filter((comment) => comment._id !== commentId);
        },
        UPDATE_COMMENT(state, updatedComment) {
            const index = state.comments.findIndex((comment) => comment._id === updatedComment._id);
            if (index !== -1) {
                state.comments.splice(index, 1, updatedComment);
            }
        },
    },
    actions: {
        async createComment({ commit }, { commentData }) {
            try {
                const response = await createComment(commentData);
                if (response && response.data) {
                    commit("ADD_COMMENT", response.data);
                } else {
                    console.error("createComment: Invalid API response:", response);
                }
            } catch (error) {
                console.error("Error creating comment:", error);
                throw error;
            }
        },
        async fetchComments({ commit }, { type, id }) {
            try {
                const response = await listComments(type, id);
                if (response && response.data && response.data.success) {
                    commit("SET_COMMENTS", response.data.data);
                } else {
                    console.error("fetchComments: Invalid API response:", response);
                }
            } catch (error) {
                console.error("Error fetching comments:", error);
                throw error;
            }
        },
        async deleteComment({ commit }, { id }) {
            try {
                await deleteComment(id);
                commit("REMOVE_COMMENT", id);
            } catch (error) {
                console.error("Error deleting comment:", error);
                throw error;
            }
        },
        async updateComment({ commit }, {id, newMessage }) {
            try {
                const response = await updateComment(id, newMessage);
                if (response && response.data) {
                    commit("UPDATE_COMMENT", response.data);
                } else {
                    console.error("updateComment: Invalid API response:", response);
                }
            } catch (error) {
                console.error("Error updating comment:", error);
                throw error;
            }
        },
    },
};

export default comments;
